import { jsx } from "react/jsx-runtime";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { validateTidalLicense } from "../../base/index.js";
function Visibility(props) {
  return /* @__PURE__ */ jsx(
    VisibilityIcon,
    {
      "data-testid": "Visibility",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Visibility",
      "data-tidal-icon-meta": "map,location,time"
    }
  );
}
Visibility.tidalIconMeta = {
  categories: "map,location,time",
  name: "Visibility"
};
validateTidalLicense();
export {
  Visibility
};
//# sourceMappingURL=Visibility.js.map
